module.exports = __webpack_public_path__ + "media/20_Long.dd7befbf.mp3";